import { useMemo } from "react";
import { useSectionViewTracking } from "@/lib/analytics";
import { useI18n } from "@/lib/i18n/use-i18n";
import {
	ContactSection,
	FocusSection,
	MissionsSection,
	ServicesSection,
	SkillsSection,
	TestimonialsSection,
} from "../sections/Sections";
import { HomeHeroSection } from "./HomeSections";

export function HomePage() {
	const { locale } = useI18n();
	const sectionTracking = useMemo(
		() => [
			{ id: "services", label: "services" },
			{ id: "missions", label: "missions" },
			{ id: "testimonials", label: "testimonials" },
			{ id: "focus", label: "focus" },
			{ id: "skills", label: "skills" },
			{ id: "contact", label: "contact" },
		],
		[],
	);
	useSectionViewTracking(sectionTracking, { pageType: "home", locale });

	return (
		<>
			<HomeHeroSection />
			<ServicesSection n="01" />
			<MissionsSection n="02" />
			<TestimonialsSection n="03" />
			<FocusSection n="04" />
			<SkillsSection n="05" />
			<ContactSection n="06" />
		</>
	);
}
